import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'

import CancelIcon from '@material-ui/icons/Cancel'
import i18n from '../../i18n'

import { Button } from '../../components/Button'
import { Modal } from '../../components/Modal'

import styles from '../styles.module.scss'

export const NotificationModal = ({ onRequestClose, ...props }) => {
  const { t } = useTranslation('modals', { keyPrefix: 'notification' })
  const { portalConfig } = useSelector((state) => state.application)
  const { notificationText } = portalConfig
  return (
    <Modal title={t('title')} {...props}>
      <div
        className={cx(styles.content, styles.agreement)}
        style={{ whiteSpace: 'pre-wrap' }}
      >
        {notificationText[i18n.language]
          ? notificationText[i18n.language]
          : t('message')}
      </div>
      <div className={styles.controls}>
        <Button
          className={styles.controlButton}
          type="button"
          variant="contained"
          disableElevation
          startIcon={<CancelIcon />}
          onClick={onRequestClose}
        >
          {t('cancel')}
        </Button>
      </div>
    </Modal>
  )
}

NotificationModal.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
}
